import React from "react";
import { QuestionAttribute } from "../../../../SignUpFormTypes/signUpFormTypes";
import MultipleChoice from "./MultipleChoice";
import UniqueChoice from "./UniqueChoice";

const QuestionsInput: React.FC<QuestionAttribute & { index: number }> = ({
  questionType,
  ...rest
}) => {
  const questionAttributes = { questionType, ...rest };

  return questionType === "multipleSelect" ? (
    <MultipleChoice {...questionAttributes} />
  ) : (
    <UniqueChoice {...questionAttributes} />
  );
};

export default QuestionsInput;
